function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_15",
  "data-name": "Path 15",
  d: "M19.8,24.852c0-2.135,1.335-2.936,3.87-5.338,1.068-.934,2.4-2.135,3.6-2l6.673,9.876a3.939,3.939,0,0,1-2.669,3.2c-2.936,2.8,10.41,17.083,13.48,14.414a3.826,3.826,0,0,1,3.337-2.536l9.342,7.474c.133,1.2-1.2,2.4-2.269,3.47-2.536,2.269-3.47,3.6-5.605,3.47C39.018,58.618,17.4,35.262,19.8,24.852Zm20.153-7.874C51.7,17.645,59.038,25.52,58.9,37.264c0,2.536-4,2.269-4,.534.267-10.01-5.739-16.416-15.748-16.95C37.417,20.715,37.417,16.845,39.953,16.978Zm-.534,11.878c-1.735,0-2-3.737.4-3.737,6.94.133,11.211,4.8,10.944,11.745-.133,2.4-3.87,1.868-3.737.133C47.16,31.792,44.624,29.123,39.419,28.856Z",
  transform: "translate(-19.615 -16.975)"
});

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39.291,
    height: 40,
    viewBox: "0 0 39.291 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.1bd35e15.svg";
export { ForwardRef as ReactComponent };